import React from 'react';
import { siteContent } from '../data/mock';

const Solution = () => {
  const { solution } = siteContent;

  return (
    <section className="py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-medium text-neutral-900 mb-12">
          {solution.title}
        </h2>
        <p className="text-lg text-neutral-700 leading-relaxed mb-8">
          {solution.intro}
        </p>
        <div className="mb-8">
          {solution.highlights.map((highlight) => (
            <p key={highlight} className="text-lg text-neutral-700">{highlight}</p>
          ))}
        </div>
        <p className="text-lg text-neutral-700 leading-relaxed mb-8">
          {solution.description}
        </p>
        <div>
          {solution.benefits.map((benefit) => (
            <p key={benefit} className="text-lg text-neutral-700">{benefit}</p>
          ))}
        </div>
        </div>
      </div>
    </section>
  );
};

export default Solution;
